import { saveAs } from "file-saver";

import getCsvContent from "astrid-helpers/src/csv/getCsvContent";

import algoliaIndexSearch from "./algoliaIndexSearch";

export default async function algoliaExportCSV({ index, columns, query, filters, attributes }) {
	const data = await algoliaIndexSearch({ index, query, filters, attributes });

	const csvContent = getCsvContent({ data, columns });

	const name = `${index}_${new Date().toISOString()}.csv`;

	const blob = new Blob([csvContent], {
		type: "text/csv;charset=utf-8;",
	});

	saveAs(blob, name);
}
